import { BorrowDialogContentContainer } from './BorrowDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export interface BorrowDialogProps extends CommonDialogProps {
  reserve: Reserve
  initialBorrowToken: SparkLendToken
}

function BorrowDialog({ reserve, initialBorrowToken, open, setOpen }: BorrowDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <BorrowDialogContentContainer
          reserve={reserve}
          initialBorrowToken={initialBorrowToken}
          closeDialog={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  )
}

export const borrowDialogConfig: DialogConfig<BorrowDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: BorrowDialog,
  name: 'BorrowDialog',
}
